import { urlParams } from './util';
const DawaApiBaseUrl = 'https://dawa.aws.dk/';

export function getAdresseringReverseGeocode(x, y) {
  return fetch(
    `${DawaApiBaseUrl}adgangsadresser/reverse/${urlParams({ x, y })}`,
    {
      method: 'GET',
    }
  )
    .then(response => {
      if (response.ok) {
        return response.json();
      } else if (response.status !== 404) {
        throw Error(response.statusText);
      }
    })
    .then(function(response) {
      return response;
    });
}
